module.exports = __webpack_public_path__ + "static/media/Home_BG_3.5ec19dfb.jpg";